import { render, staticRenderFns } from "./CervettiDashboard.vue?vue&type=template&id=883289d6&"
import script from "./CervettiDashboard.vue?vue&type=script&lang=js&"
export * from "./CervettiDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CervettiDashboard.vue?vue&type=style&index=0&id=883289d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports